module.exports = "/virtual-football-league/img/amblems/left/logos/Lev.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/left/logos/Lev.png
// module id = 2104
// module chunks = 4